module.exports = __webpack_public_path__ + "img/Trevor.96e06277.jpg";